/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface RemixersResponse
 */
export interface RemixersResponse {
    /**
     * 
     * @type {Array<User>}
     * @memberof RemixersResponse
     */
    data?: Array<User>;
}

/**
 * Check if a given object implements the RemixersResponse interface.
 */
export function instanceOfRemixersResponse(value: object): value is RemixersResponse {
    let isInstance = true;

    return isInstance;
}

export function RemixersResponseFromJSON(json: any): RemixersResponse {
    return RemixersResponseFromJSONTyped(json, false);
}

export function RemixersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemixersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(UserFromJSON)),
    };
}

export function RemixersResponseToJSON(value?: RemixersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(UserToJSON)),
    };
}

